import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared.module';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationComponent } from './components/navigation/navigation.component';
import { AuthService } from './services/auth/auth.service';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { appInitializerFactory } from './services/auth/app-initializer.factory';
import { AuthConfigService } from './services/auth/auth-config.service';
import { AuthGuard } from './services/auth/auth-guards';
import { AuthorizationGuard } from './services/auth/authorization-guards';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { provideNgxMask } from 'ngx-mask';


// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
  return sessionStorage;
}

@NgModule({
    declarations: [AppComponent, NavigationComponent, AccessDeniedComponent],
    imports: [
        SharedModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        FontAwesomeModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatDividerModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
        BrowserModule,
        AppRoutingModule,
        OAuthModule.forRoot(),
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [AuthConfigService, AuthService],
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: OAuthStorage, useFactory: storageFactory },
        AuthGuard,
        AuthorizationGuard,
        provideNgxMask()
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
